import { useApi } from '@mainstage/core-plugin-api';
import { notificationApiRef } from '../notificationApiRef';
import { useQuery } from '@tanstack/react-query';
import { NotificationBindingsGetRequest } from '@agilelab/plugin-wb-notification-common';
import { WEBHOOKS_NOTIFICATIONS_KEY } from './reactQuery';

export const useNotificationBindings = (
  params: NotificationBindingsGetRequest,
) => {
  const notificationApi = useApi(notificationApiRef);
  return useQuery({
    queryKey: [WEBHOOKS_NOTIFICATIONS_KEY, params],
    queryFn: () => notificationApi.getNotificationBindings(params),
  });
};
